import { render, staticRenderFns } from "./StatsMenagement.vue?vue&type=template&id=4f41e729&scoped=true"
import script from "./StatsMenagement.vue?vue&type=script&lang=js"
export * from "./StatsMenagement.vue?vue&type=script&lang=js"
import style0 from "./StatsMenagement.vue?vue&type=style&index=0&id=4f41e729&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f41e729",
  null
  
)

export default component.exports